/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "azure-devops-ui/Pill", "azure-devops-ui/PillGroup", "azure-devops-ui/Util", "../Utils", "react", "./Tags.scss"], function (require, exports, Pill_1, PillGroup_1, Util_1, Utils_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Tags = /** @class */ (function (_super) {
        __extends(Tags, _super);
        function Tags() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Tags.prototype.render = function () {
            var items = this.props.showOnlyValues ? this.props.items : Utils_1.Utils.getPillTags(this.props.items);
            return (React.createElement(PillGroup_1.PillGroup, { className: Util_1.css(this.props.className, "k8s-tags", "flex-row"), overflow: 2 /* fade */ }, items && items.map(function (tagText, index) { return React.createElement(Pill_1.Pill, { key: index, className: "k8s-tag-pill", size: 0 /* compact */ }, tagText); })));
        };
        return Tags;
    }(React.Component));
    exports.Tags = Tags;
});
